import * as LiveSessionStates from "../constants/liveSessionStates";
import * as UserRoles from "../constants/roles";

const nextStepAvailableUpdates = {
  [LiveSessionStates.SCHEDULED]: LiveSessionStates.READY,
  [LiveSessionStates.READY]: LiveSessionStates.STREAMING,
  [LiveSessionStates.STREAMING]: LiveSessionStates.FINISHED,
};

/**
 * Checks if the nextState is suitable for the LiveSession, given the current one
 * @param {String} currentState
 * @param {String} nextState
 */
export const canSetNextLiveSessionState = (currentState, nextState) => {
  return nextStepAvailableUpdates[currentState] === nextState;
};

/**
 * Checks if it's possible to edit the live session
 * @param {String} currentState
 */
export const canEditLiveSession = (currentState) => {
  return currentState === LiveSessionStates.SCHEDULED;
};

/**
 * Checks if it's possible to cancel the live session
 * @param {String} currentState
 */
export const canCancelLiveSession = (currentState) =>
  [LiveSessionStates.SCHEDULED, LiveSessionStates.READY, LiveSessionStates.STREAMING].indexOf(
    currentState
  ) >= 0;

/**
 * Checks if the local LiveSession can be set to STREAMING
 * @param {String} currentState
 */
export const canSetLocalLiveSessionStreaming = (currentState) =>
  [LiveSessionStates.SCHEDULED, LiveSessionStates.READY].indexOf(currentState) >= 0;

/**
 * Checks if the current LS state is ready for presenting the LiveFeedback Modal
 * @param {String} currentState
 */
export const canShowLiveFeedbackModalState = (currentState) =>
  [LiveSessionStates.STREAMING, LiveSessionStates.FINISHED].indexOf(currentState) >= 0;

/**
 * Checks if the current LS state can play recording
 * @param {String} currentState
 */
export const canPlayLiveRecording = (currentState) => currentState === LiveSessionStates.FINISHED;

/**
 * Checks if the local LiveSession should show the OnBeforeUnload alert
 * @param {String} currentState
 * @param {String} nextState
 */
export const shouldShowBeforeUnloadAlert = ({ currentState, userRole }) => {
  return (
    userRole === UserRoles.TEACHER &&
    [LiveSessionStates.READY, LiveSessionStates.STREAMING].indexOf(currentState) >= 0
  );
};

/**
 * Checks if the current LS state should show the Player Countdown
 * @param {String} currentState
 */
export const shouldShowCountdown = (currentState) =>
  [LiveSessionStates.SCHEDULED, LiveSessionStates.READY].indexOf(currentState) >= 0;

/**
 * Checks if the current LS state should show the ReadyToLive Alert
 * @param {String} currentState
 */
export const shouldShowReadyToLiveAlert = (currentState) =>
  [LiveSessionStates.SCHEDULED, LiveSessionStates.READY].indexOf(currentState) >= 0;
